"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _getCookies = _interopRequireDefault(require("../../getCookies"));

var _trackers = require("../../trackers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var UFTI = function UFTI() {
  /**
   * The cookie can techically change without informing us but we are going to ignore that.
   */
  (0, _react.useEffect)(function () {
    var cookies = (0, _getCookies["default"])();
    var ufti = cookies === null || cookies === void 0 ? void 0 : cookies.ufti;

    _trackers.pulse.update({
      object: {
        custom: {
          consents: ufti
        }
      }
    });

    _trackers.gtm.update({
      consents: ufti
    });
  }, []);
  return null;
};

var _default = UFTI;
exports["default"] = _default;
//# sourceMappingURL=UFTI.js.map